import styled from 'styled-components';

export const EmptyArea = styled.div`
    margin: auto;
    width: 50%;
    height: auto;
    position: relative;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}
`;

export const Description = styled.span`
font-size: 13px;
color: #8c8c8c;
font-weight: 200;
`;